import Link from '@/models/pre-ts/navigation/Link';

/**
 * @class
 */
export class SidebarItem {
    /**
     * @constructor
     * @param {string} text
     * @param {Link} link
     */
    constructor({ text, link = {} }) {
        this.text = text;
        this.link = link;
    }
}

/**
 * @class
 */
export default class Sidebar {
    /**
     * @constructor
     * @param {string} title
     * @param {SidebarItem[]} items
     */
    constructor({ title, items = [] }) {
        this.title = title;
        this.items = items;
    }
}
